import { AnalyticsStore } from 'bernie-plugin-mobx';
import { AnalyticsConfig } from 'uitk-react-utils';

import { AnalyticsType } from 'types/shared';
import { ClientSideAnalyticsFragment, FlightsFilterItemAnalyticsFragment, FlightsTripType } from '__generated__/api';

export const TRIP_TYPE_MAPPER = {
  ONE_WAY: 'OW',
  ROUND_TRIP: 'RT',
  MULTI_DESTINATION: 'MD'
};

export const analyticsConfigMapper = (
  analytics: AnalyticsType | ClientSideAnalyticsFragment,
  analyticsStore: AnalyticsStore,
  trackImmediate?: boolean
): AnalyticsConfig => {
  const { linkName, referrerId } = analytics;

  return {
    id: referrerId,
    callback: (referrerId: string, name: string) =>
      analyticsStore.trackEvent(referrerId, name, null, null, trackImmediate),
    localAnalyticsId: null,
    description: linkName
  };
};

export function trackAnalytics(
  analytics: AnalyticsType,
  analyticsStore: AnalyticsStore,
  rfrrToken?: string,
  rfrrReplacement?: string
) {
  let rfrr = analytics?.referrerId;
  if (rfrrToken && rfrr) {
    rfrr = rfrr.replace(rfrrToken, rfrrReplacement);
  }

  if (analytics && analyticsStore) {
    analyticsStore.trackEvent(rfrr, analytics.linkName, analyticsStore.omnitureData, null, true);
  }
}

export function trackJourneyAnalytics(analytics: AnalyticsStore, fieldAnalytics: AnalyticsType, tripIndex: number) {
  trackAnalytics(fieldAnalytics, analytics, '${X}', tripIndex.toString());
}

export function trackSearchFormAnalytics(
  analytics: AnalyticsStore,
  fieldAnalytics: AnalyticsType,
  flightType: string,
  leg?: number
) {
  const legText = leg && flightType === FlightsTripType.MULTI_DESTINATION ? leg : '';

  return trackAnalytics(fieldAnalytics, analytics, '${tripType}', `${TRIP_TYPE_MAPPER[flightType]}${legText}`);
}

export function trackAnalyticsList(
  analytics: AnalyticsType[] | ClientSideAnalyticsFragment[],
  analyticsStore: AnalyticsStore
) {
  if (analyticsStore && analytics) {
    analytics.forEach(analytic => {
      analyticsStore.trackEvent(analytic.referrerId, analytic.linkName, analyticsStore.omnitureData, null, true);
    });
  }
}

export const trackCountsFormAnalytics = (analytics: AnalyticsStore, fieldAnalytics: AnalyticsType, count: number) => {
  return trackAnalytics(fieldAnalytics, analytics, 'X', `${count}`);
};

export const validateFilterAnalytics = (filterItemAnalytic: Omit<FlightsFilterItemAnalyticsFragment, '__typename'>) =>
  filterItemAnalytic?.id && filterItemAnalytic?.value && filterItemAnalytic?.position && filterItemAnalytic?.category;
